import { Component, ReactNode } from "react";
import axios from "axios";
import Forward from "./Forward";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorCode: number;
  skipErrorHandling?: boolean;
}

export default class ErrorHandler extends Component<Props, State> {
  public state: State = {
    hasError: false,
    errorCode: 0
  };

  componentDidMount() {
    axios.interceptors.request.use((req) => {
      this.setState({ hasError: false, skipErrorHandling: req.data?.skipErrorHandling });
      return req;
    });

    axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (this.state.skipErrorHandling) {
          this.setState({ hasError: false, errorCode: 0, skipErrorHandling: false });
        } else {
          this.setState({ hasError: true, errorCode: error.response.status });
        }

        return Promise.reject(error);
      }
    );
  }

  public render() {
    if (this.state.hasError) {
      if (this.state.errorCode === 404) {
        return <Forward path="/notFound" />;
      } else if (this.state.errorCode === 500) {
        return (
          <div>
            <h1>Sorry...internal error.</h1>
            <div>Please try agian later.</div>
          </div>
        );
      }
    } else {
      return this.props.children;
    }
  }
}
